import { render } from "./RandomRotationTarget.vue?vue&type=template&id=670890ce"
import script from "./RandomRotationTarget.vue?vue&type=script&lang=js"
export * from "./RandomRotationTarget.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__